import { render, staticRenderFns } from "./SalesEnquiryContactInfo.vue?vue&type=template&id=28e02ef5&scoped=true&"
import script from "./SalesEnquiryContactInfo.vue?vue&type=script&lang=js&"
export * from "./SalesEnquiryContactInfo.vue?vue&type=script&lang=js&"
import style0 from "./SalesEnquiryContactInfo.vue?vue&type=style&index=0&id=28e02ef5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e02ef5",
  null
  
)

export default component.exports